import get from 'lodash.get';

export const selectTaxConditions = state => {
  const { taxConditions } = state.step4Module2;

  return { taxConditionOpts: taxConditions.map(c => ({ id: c.id, name: c.description })), taxConditions };
};

export const selectCurrentProduct = state => {
  return state.step4Module2.selectedProduct;
};

export const selectCurrentTaxCondition = state => {
  const { ecommerceUser, taxConditions } = state.step4Module2;
  return taxConditions.find(c => c.id === ecommerceUser.billingInfo.taxCondition);
};

export const selectBillingInfo = reduxState => {
  const {
    billingInfo: { country, city, state, location, ...rest }
  } = reduxState.step4Module2.ecommerceUser;
  return rest;
};

export const selectProductTaxesParams = state => {
  const { ecommerceUser, selectedProduct } = state.step4Module2;
  return { userId: ecommerceUser.id, productId: selectedProduct.id };
};

export const selectAvailableLocations = state => {
  return state.step4Module2.availableLocations;
};

export const selectUserLocation = reduxState => {
  const { billingInfo } = reduxState.step4Module2.ecommerceUser;

  return {
    country: billingInfo.country,
    state: billingInfo.state,
    city: billingInfo.city,
    location: billingInfo.location
  };
};

export const selectEcommerceUser = state => {
  const { ecommerceUser, selectedProduct } = state.step4Module2;
  return { ...ecommerceUser, userType: selectedProduct.priceList };
};

export const selectProductTaxes = state => {
  return {
    taxes: get(state.step4Module2, 'productTaxes.taxes', 0),
    subtotal: get(state.step4Module2, 'productTaxes.subtotal', 0),
    total: get(state.step4Module2, 'productTaxes.total', 0),
    percent: get(state.step4Module2, 'productTaxes.percent', 0),
    labelTaxes: get(state.step4Module2, 'productTaxes.labelTaxes', null),
    labelSubtotal: get(state.step4Module2, 'productTaxes.labelSubtotal', null),
    labelTotal: get(state.step4Module2, 'productTaxes.labelTotal', null),
    labelPercent: get(state.step4Module2, 'productTaxes.labelPercent', null),
    discount: get(state.step4Module2, 'productTaxes.discount', null),
    discountPercent: get(state.step4Module2, 'productTaxes.discountPercent', null),
    coupon: get(state.step4Module2, 'productTaxes.coupon', null),
    userId: get(state.step4Module2, 'productTaxes.userId', null),
    labelDiscount: get(state.step4Module2, 'productTaxes.labelDiscount', null),
    labelDiscountPercent: get(state.step4Module2, 'productTaxes.labelDiscountPercent', null),
    labelUpgradeDiscount: get(state.step4Module2, 'productTaxes.labelUpgradeDiscount', null),
    error: state.step4Module2.error,
    productTaxesError: state.step4Module2.productTaxesError
  };
};

export const getPaymentLoadingStatus = state => {
  return state.step4Module2.loading || state.step4Module2.manualLoading;
};

export const getOrderData = state => {
  return state.step4Module2.order;
};
